import { connect } from 'react-redux';
import { exitDuperbrowse } from '../redux/actionCreators';
import { getDuperbrowseStreamParent, getCurrentItem } from '../redux/selectors';
const mapStateToProps = (state)=>({
        parent: getDuperbrowseStreamParent(state),
        currentItem: getCurrentItem(state)
    });
const mapDispatchToProps = {
    exitDuperbrowse
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=BackToStreamButton.container.js.map